import { render, staticRenderFns } from "./BCXMultiselectSection.vue?vue&type=template&id=372b7740&scoped=true"
import script from "./BCXMultiselectSection.vue?vue&type=script&lang=ts"
export * from "./BCXMultiselectSection.vue?vue&type=script&lang=ts"
import style0 from "./BCXMultiselectSection.vue?vue&type=style&index=0&id=372b7740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372b7740",
  null
  
)

export default component.exports